import React from "react";
import { dispatchMonetateQEvent } from "../../utils/monetate/monetateQ";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { PRODUCT_SIZE_AND_FIT_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductSizeAndFitAccordion/ProductSizeAndFitAccordionUI";

const SIZE_INFO_CLICK_EVENT = "size_and_fit_click_event";

export const SizeAndFitCtaUI = () => {
  const dispatchAccordionOpenEvent = () => {
    const event = new CustomEvent(
      `jlds:accordion:${PRODUCT_SIZE_AND_FIT_ACCORDION_INSTANCE_NAME}`,
      {
        detail: { action: "open" },
      },
    );
    document.body.dispatchEvent(event);
  };

  const handleSizeAndFitCtaClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    dispatchAccordionOpenEvent();
    document
      .querySelector(e.currentTarget.getAttribute("href") || "")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    dispatchMonetateQEvent(SIZE_INFO_CLICK_EVENT);
  };

  return (
    <UnderlinedButton
      tag="a"
      href="#accordion-size-and-fit"
      onClick={handleSizeAndFitCtaClick}
      data-testid="size-and-fit-CTA"
    >
      {`See size and fit details`}
    </UnderlinedButton>
  );
};
